import { TrackerProgressTile, TrackerProgressTileProps } from "../TrackerProgressTile";

import { TrackerType } from "core/state/Trackers/TrackerType";
import { ReactComponent as WaterIcon } from "@icons/water.svg";
import { useTranslation } from "react-i18next";

interface WaterTrackerProgressTileProps {
  inCard?: boolean;
  size?: TrackerProgressTileProps["size"];
}

export const WaterTrackerProgressTile = ({ inCard, size = "lg" }: WaterTrackerProgressTileProps) => {
  const { t } = useTranslation();

  return (
    <TrackerProgressTile
      trackerType={TrackerType.Water}
      trackerPagePath="water"
      Icon={WaterIcon}
      caption={t("wellbeing.trackers.water.caption")}
      wrapInCard={inCard ?? true}
      size={size}
    />
  );
};
